'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Panel, PanelContent } from '@/components/ui/panel';
import { useIntentRoutePrefetch } from '@/hooks/use-intent-route-prefetch';
import { Link } from '@/i18n/navigation';
const HOT_TAKE_FLAME_SRC = '/assets/hot-take-flame.png';
const HOT_TAKE_FLAME_SIZE_PX = 96;
export function SparseCard() {
  const $ = _c(18);
  const t = useTranslations("markets");
  const intent = useIntentRoutePrefetch("/proposals");
  let t0;
  if ($[0] !== t) {
    t0 = t("sparse.cta");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden="true" className="relative size-24 shrink-0 overflow-hidden"><Image src={HOT_TAKE_FLAME_SRC} alt="" width={HOT_TAKE_FLAME_SIZE_PX} height={HOT_TAKE_FLAME_SIZE_PX} className="size-full object-contain" /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("sparse.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="text-heading-lg">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("sparse.cta");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <AnimatedButton variant="secondary" size="sm" asChild={true}><span>{t4}</span></AnimatedButton>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <Panel surface="solid" elevation="flat" className="h-full min-h-0 cursor-pointer overflow-hidden transition-[box-shadow,border-color] duration-fast ease-default motion-reduce:transition-none hover:border-border-primary hover:shadow-elevation-card"><PanelContent className="flex h-full min-h-0 flex-col items-center justify-center gap-4 p-6 text-center">{t1}{t3}{t5}</PanelContent></Panel>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== intent || $[15] !== t0 || $[16] !== t6) {
    t7 = <Link href="/proposals" prefetch={false} {...intent} aria-label={t0} className="block h-full min-h-0 rounded-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-primary md:aspect-[4/3]">{t6}</Link>;
    $[14] = intent;
    $[15] = t0;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}